import { Button, Input, Space, Typography, message } from 'antd';

const { Paragraph, Text } = Typography;

export interface SetupCredentialsNoticeProps {
  email: string;
  setupLink?: string | null;
  /** Extra note under the link (e.g. phone login for drivers) */
  extraNote?: string;
}

/**
 * Share one-time setup / recovery link — never a long-lived plaintext password.
 */
export function SetupCredentialsNotice({
  email,
  setupLink,
  extraNote,
}: SetupCredentialsNoticeProps) {
  const copy = async () => {
    if (!setupLink) return;
    try {
      await navigator.clipboard.writeText(setupLink);
      message.success('Link copied');
    } catch {
      message.warning('Copy failed — select the link manually');
    }
  };

  return (
    <div>
      <Paragraph>
        Login identity: <Text strong>{email}</Text>
      </Paragraph>
      {setupLink ? (
        <>
          <Paragraph type="secondary" style={{ fontSize: 13 }}>
            One-time password setup link (expires soon). Share it securely — do not send a long-lived
            password by email or chat.
          </Paragraph>
          <Input.TextArea value={setupLink} readOnly rows={4} style={{ marginBottom: 8 }} />
          <Space>
            <Button type="primary" onClick={() => void copy()}>
              Copy link
            </Button>
          </Space>
        </>
      ) : (
        <Paragraph type="warning">
          Account linked, but no setup link was generated. Ask the user to use Forgot password on the
          portal, or retry Send password setup link.
        </Paragraph>
      )}
      {extraNote ? (
        <Paragraph type="secondary" style={{ marginTop: 12, fontSize: 13 }}>
          {extraNote}
        </Paragraph>
      ) : null}
    </div>
  );
}

export default SetupCredentialsNotice;
